export default __webpack_public_path__ + "static/media/lock-solid.a11cbdc7.svg";